<div *ngIf="buttonShow">
  <div class="pt-20"></div>
  <div class="center">
    <img src="../../../assets/imgs/icon.png" class="img-fluid2 logo-icon-resize">
  </div>

  <h2 id="b2borb2c" class="h2-blue-light">Welcome</h2>
  <p id="b2borb2c" class="sub-txt">Let's get started! This form will assess your business model and operations progress.</p>
  <p id="b2borb2c" class="sub-txt">Fill out ALL questions, even if you haven't started operating yet.</p>
  <p id="b2borb2c" class="sub-txt">Note: The assessment is not timed but you must complete the assessment in one session. Your answers don't save if you don't submit the assessment. </p>
  <div class="pt-2"></div>
  <div class="btn-group">
    <button mat-raised-button class="btn-blue-royal" (click)="toggleStart()"> Start</button>
  </div>
</div>

      <!--Practicality-->
      <div *ngIf="showAll">
      <mat-vertical-stepper orientation="vertical" #stepper>
        <mat-step [stepControl]="assessmentForm">
      <form *ngIf="assessmentForm" [formGroup]="assessmentForm">
            <!-- <div formGroupName="busiPlanArray"> -->
              <ng-template matStepLabel>Company History</ng-template>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Business Name" formControlName="busiName">
                    <mat-error *ngIf="assessmentForm.controls['busiName'].hasError('required')">
                      Business Name is
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="First name" formControlName="busiFirstName">
                    <mat-error *ngIf="assessmentForm.controls['busiFirstName'].hasError('required')">
                      First name is
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Last name" formControlName="busiLastName">
                    <mat-error *ngIf="assessmentForm.controls['busiLastName'].hasError('required')">
                      Last name is
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Email" type="email" formControlName="busiEmail">
                    <mat-error *ngIf="assessmentForm.controls['busiEmail'].hasError('required')">
                      Email
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Phone Number" type="text" formControlName="busiTelephone">
                    <mat-error *ngIf="assessmentForm.controls['busiTelephone'].hasError('required')">
                      Phone number
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <label>Well, hello there! Tell us about your business or idea.</label>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label> What are you offering?</label>
                    <mat-select placeholder="" formControlName="offerType">
                      <mat-option  *ngFor="let offer of offerType" (onSelectionChange)="handleProductServiceQuestions($event, offer.name)" 
                       [value]="offer">
                        {{offer.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['offerType'].hasError('required')">
                      Please select an offering type
                    </mat-error>
                  </mat-form-field>
                </div>
                 <div class="col">
                <mat-form-field class="full-width">
                  <label> What industry are you in? </label>
                  <mat-select placeholder="" formControlName="offerIndustry">
                    <mat-option *ngFor="let industry of offerIndustryFull" (onSelectionChange)="handleIndustrySubcategories($event, industry.name, false)" [value]="industry">
                      {{industry.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerIndustry'].hasError('required')">
                    Please select an industry
                  </mat-error>
                </mat-form-field>

              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label> What sub-category are you in? </label>
                  <mat-select placeholder="" formControlName="offerIndustrySubcategory">
                    <mat-option *ngFor="let subindustry of offerIndustrySubcategoryFull" (onSelectionChange)="handleIndustryBarriers($event, subindustry.name, false)" [value]="subindustry">
                      {{subindustry.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerIndustrySubcategory'].hasError('required')">
                    Please select a sub industry
                  </mat-error>
                </mat-form-field>
              </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>What is your method of operations in the next 3 years? Select all that apply. </label>
                    <mat-select placeholder="" formControlName="operationsMethods" multiple>
                      <mat-option  *ngFor="let oMethods of operationsMethods" [value]="oMethods">
                        {{oMethods.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['operationsMethods'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>How much financing or capital are you looking for?</label>
                    <mat-select placeholder=" " formControlName="capitalSeeking">
                      <mat-option *ngFor="let cSeeking of capitalSeeking" [value]="cSeeking">
                        {{ cSeeking.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['capitalSeeking']">
                      Please select yes or no
                    </mat-error>
                  </mat-form-field>
                </div>
            </div>
              <div>
                <button mat-button matStepperNext>Next</button>
              </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="assessmentForm">
          <form [formGroup]="assessmentForm">
            <ng-template matStepLabel>Industry & Strategy</ng-template>
            <label>Glad to know! Time to assess, let’s start with Strategy.</label>
                  <div class="row"> 
                  <div class="col">
                    <mat-expansion-panel (opened)="panelOpenState = true"
                    (closed)="panelOpenState = false" >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                        Do you have these for your business?
                        </mat-panel-title>
                      </mat-expansion-panel-header>   
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Business Plan Sections</th>
                          </tr>
                        </thead>
                        <tbody>
                           <div formArrayName="busiPlanArray">
                          <tr>
                              <td>
                                Executive Summary or One Pager
                              </td>
                              <mat-radio-group formControlName="busiPlanExecSum">
                            <td class="td-style "> 
                              Does not exist
                              <mat-radio-button  [value]='0' ></mat-radio-button>
                            </td>
                            <td  class="td-style ">
                              Needs work
                              <mat-radio-button [value]='1' ></mat-radio-button>
                            </td>
                            <td class="td-style " >
                              Good to go
                              <mat-radio-button [value]='2'></mat-radio-button>
                            </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Mission, Vision, Goals</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanMisVisGoal">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Business Summary</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanBusiSum">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Services and Products Description</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanOfferDescrip">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Industry Overview or Insights</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanIndustryOverview">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Target Market Description or Insights</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanTargetMarket">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Marketing Summary or Plan</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanMarketingSummary">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Sales Strategy or Plan</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanSaleStrategy">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Team Overview or Biography</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanTeamOverview">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          <tr>
                            <td>
                              <p>Financial Projections</p>
                            </td>
                            <mat-radio-group formControlName="busiPlanFinancialProjections">
                              <td class="td-style "> 
                                Does not exist
                                <mat-radio-button [value]='0' ></mat-radio-button>
                              </td>
                              <td  class="td-style ">
                                Needs work
                                <mat-radio-button [value]='1' ></mat-radio-button>
                              </td>
                              <td class="td-style " >
                                Good to go
                                <mat-radio-button [value]='2'></mat-radio-button>
                              </td>
                          </mat-radio-group>
                          </tr>
                          </div>
                        </tbody>
                      </table>
                     </mat-expansion-panel>
              </div>
              </div>
              <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How is your business different than competitors?
                    <mat-icon class="matTooltip" matSuffix matTooltip="Differentiation is how the offering may differ from competitors or substitutes">info</mat-icon>
                  </label>
                  <mat-select *ngIf="!isNonePI6" placeholder="" formControlName="offerDifferentiation"  multiple >
                        <mat-option *ngFor="let oDiff of offerDifferentiationFull"  [value]="oDiff"  > {{oDiff.name}} </mat-option>
                        <mat-option (onSelectionChange)="isNoneSelected(26)"  *ngFor="let oDiff of noneAbove"  [value]="oDiff">  {{oDiff.name}}</mat-option>
                  </mat-select>
                  <mat-select *ngIf="isNonePI6" placeholder=""  formControlName="offerDifferentiation" multiple>          
                        <mat-option (click)="isNoneSelected(26)"  *ngFor="let oDiff of noneAbove"  [value]="oDiff" selected > {{oDiff.name}} </mat-option>
                  </mat-select>
                <!-- <mat-error *ngIf="assessmentForm.controls['offerDifferentiation'].hasError('required')"> Please select one differentiation </mat-error>--> 
                </mat-form-field>   
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>In which case do you think your business customers are dissatisfied with your competitors?</label>  
                        <mat-select *ngIf="!isNoneMI7" placeholder="" formControlName="pmfCompetitorDissatisfaction" multiple >
                                      <mat-option
                                       *ngFor="let competitorDissatisfaction of pmfCompetitorDissatisfactionFull"      [value]="competitorDissatisfaction">
                                                {{competitorDissatisfaction.name}}
                                      </mat-option>
                                      <!-- <mat-option (onSelectionChange)="isNoneSelected(211)"  *ngFor="let oSupplierType of offerSupplierTypeNone"> {{oSupplierType.name}} </mat-option> -->
                                      <mat-option (click)="isNoneSelected(20)" *ngFor="let nbv of noneAbove" [value]="nbv">
                                                {{nbv.name}}
                                      </mat-option>
                        </mat-select>
                        <mat-select *ngIf="isNoneMI7" placeholder=""  formControlName="pmfCompetitorDissatisfaction" multiple>
                                  <mat-option (click)="isNoneSelected(20)"  *ngFor="let competitorDissatisfaction of noneAbove" [value]="competitorDissatisfaction" selected >
                                           {{competitorDissatisfaction.name}}
                                  </mat-option>
                        </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['pmfCompetitorDissatisfaction'].hasError('required')">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How easy would it be to switch suppliers if you needed to? 
                    <!--TODO - how vulnerable are your sales to price sensitivty, if the price were to change, how many customers would stay vs leave?-->
                  </label>
                  <mat-select placeholder="" formControlName="offerSupplierPower">
                    <mat-option *ngFor="let oSupplierPower of offerSupplierPower" [value]="oSupplierPower">
                      {{oSupplierPower.name}}
                    </mat-option>
                  </mat-select>
                 <mat-error *ngIf="assessmentForm.controls['offerSupplierPower'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              </div>
              <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How many known competitors, or substitutes, do you have? </label>
                  <mat-select placeholder="" formControlName="knownCompetition">
                    <mat-option *ngFor="let kCompetition of knownCompetition" [value]="kCompetition">
                      {{kCompetition.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['knownCompetition'].hasError('required')">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
              <div #IndustryBarriers style="display:none"> 
              <div class="col"> 
                <mat-form-field class="full-width">
                  <label>These seem to be potential barriers for your industry. Out of this list, which have you already overcome?
                  </label> 
                  <mat-select *ngIf="!isNoneI1" placeholder="" formControlName="industryBarriersOvercome" [value]="assessmentForm.controls.industryBarriersOvercome.value" multiple >
                       <mat-option *ngFor="let  iBarriersOvercome of industryBarriersOvercomeFull"    [value]=" iBarriersOvercome"  >  
                              {{iBarriersOvercome.name}}
                        </mat-option>
                      <mat-option (click)="isNoneSelected(24)" *ngFor="let iBarriersOvercome of noneAbove" [value]="iBarriersOvercome" >
                          {{iBarriersOvercome.name}}
                      </mat-option>
                   </mat-select>
                   <mat-select *ngIf="isNoneI1" placeholder=""  formControlName="industryBarriersOvercome" multiple>
                        <mat-option (click)="isNoneSelected(24)" *ngFor="let iBarriersOvercome of noneAbove" [value]="iBarriersOvercome" >
                            {{iBarriersOvercome.name}}
                        </mat-option>
                   </mat-select>
                </mat-form-field>
              </div>
              </div>
              </div>
              <div #GeneralIndustryBarriers style="display:none"> 
              <div class="row">
                <div class="col">
                <mat-form-field class="full-width">
                  <label>What barriers could you possibly run into while starting or operating this business? Select all that apply</label>
                  <mat-select *ngIf="!isNonePI8" placeholder="" formControlName="generalIndustryBarriers" multiple >
                   <span *ngFor="let  gIndustryBarriers of generalIndustryBarriers"  >
                      <mat-option  *ngIf="gIndustryBarriers.value==1" (onSelectionChange)="selectChange($event, gIndustryBarriers.value, gIndustryBarriers.name, false, isNonePI8)" [value]=" gIndustryBarriers"  > 
                        {{gIndustryBarriers.name}}</mat-option>
                      <mat-option  *ngIf="gIndustryBarriers.value ==0" (onSelectionChange)="selectChange($event,gIndustryBarriers.value, gIndustryBarriers.name, true, isNonePI8)" [value]=" gIndustryBarriers"  > 
                        {{gIndustryBarriers.name}}</mat-option>
                   </span>
                  </mat-select>
                  <mat-select *ngIf="isNonePI8" placeholder=""  formControlName="generalIndustryBarriers" multiple>
                    <span *ngFor="let  gIndustryBarriers of generalIndustryBarriers"  >
                       <mat-option  selected *ngIf="gIndustryBarriers.value==0" (onSelectionChange)="selectChange($event,gIndustryBarriers.value, gIndustryBarriers.name, false, isNonePI8)"[value]=" gIndustryBarriers"  >  
                            {{gIndustryBarriers.name}}
                      </mat-option>
                   </span>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col"> 
                <mat-form-field class="full-width">
                  <label>What challenges have you already overcome to start the business? Select all that apply
                  </label> 
                  <mat-select *ngIf="!isNoneTI7" placeholder="" formControlName="generalBarriersOvercome" [value]="assessmentForm.controls.generalBarriersOvercome.value" multiple >
                       <mat-option *ngFor="let  gBarriersOvercome of generalBarriersOvercomeFull"    [value]=" gBarriersOvercome"  >  
                              {{gBarriersOvercome.name}}
                        </mat-option>
                      <mat-option (click)="isNoneSelected(47)" *ngFor="let gBarriersOvercome of noneAbove" [value]="gBarriersOvercome" >
                          {{gBarriersOvercome.name}}
                      </mat-option>
                   </mat-select>
                   <mat-select *ngIf="isNoneTI7" placeholder=""  formControlName="generalBarriersOvercome" multiple>
                        <mat-option (click)="isNoneSelected(47)" *ngFor="let gBarriersOvercome of noneAbove" [value]="gBarriersOvercome" >
                            {{gBarriersOvercome.name}}
                        </mat-option>
                   </mat-select>
                </mat-form-field>
              </div>
            </div>
            </div>
              <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button matStepperNext>Next</button>
              </div>
          </form>
          </mat-step>
          <mat-step [stepControl]="assessmentForm">
            <form [formGroup]="assessmentForm">
              <ng-template matStepLabel>Customers & Marketing</ng-template>
              <label>Now time to understand your customer and how  you (will) reach them.</label>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>Are you selling to consumers or to other businesses?</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BC">
                      <mat-option *ngFor="let mTargetB2BC of marketTargetB2BC" (onSelectionChange)="handleB2BC($event, mTargetB2BC.name)" [value]="mTargetB2BC">
                        {{ mTargetB2BC.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BC'].hasError('required')">
                      Please enter the business selling type
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div #B2B style="display:none"> 
                <div class="row">

              <div class="col">
                <mat-form-field class="full-width">
                  <label>Finish the sentence. We're targeting businesses of a specific...?
                  </label>
                  <mat-select *ngIf="!isNoneB2BTM" placeholder="" formControlName="B2BTargetMarket" multiple >
                            <mat-option *ngFor="let B2BTM of B2BTargetMarketFull"  [value]="B2BTM"> {{B2BTM.name}} </mat-option>
                            <mat-option (onSelectionChange)="isNoneSelected(40)"  *ngFor="let B2BTM of noneAbove"  [value]="B2BTM">     {{B2BTM.name}} </mat-option>                   
                  </mat-select>
                  <mat-select *ngIf="isNoneB2BTM" placeholder=""  formControlName="B2BTargetMarket" multiple>                         
                            <mat-option (click)="isNoneSelected(40)" *ngFor="let B2BTM of noneAbove"  [value]="B2BTM" selected >    {{B2BTM.name}}  </mat-option>
                  </mat-select>
                  <!--<mat-error *ngIf="assessmentForm.controls['B2BTM'].hasError('required')">
                    Please select all that apply
                  </mat-error>-->
                </mat-form-field>
              </div>
              <!--  <div class="col">
                    <mat-form-field class="full-width">
                      <label>In which case do you think your business customers are dissatisfied with your competitors?</label>  
                            <mat-select *ngIf="!isNoneMI8" placeholder="" formControlName="pmfB2BCompetitorDissatisfaction" multiple >
                                          <mat-option
                                           *ngFor="let b2bCompetitorDissatisfaction of pmfB2BCompetitorDissatisfactionFull"      [value]="b2bCompetitorDissatisfaction">
                                                    {{b2bCompetitorDissatisfaction.name}}
                                          </mat-option>
                                          <!-- <mat-option (onSelectionChange)="isNoneSelected(211)"  *ngFor="let oSupplierType of offerSupplierTypeNone"> {{oSupplierType.name}} </mat-option> 
                                          <mat-option (click)="isNoneSelected(38)" *ngFor="let nbv of noneAbove" [value]="nbv">
                                                    {{nbv.name}}
                                          </mat-option>
                            </mat-select>
                            <mat-select *ngIf="isNoneMI8" placeholder=""  formControlName="pmfB2BCompetitorDissatisfaction" multiple>
                                      <mat-option (click)="isNoneSelected(38)"  *ngFor="let b2bCompetitorDissatisfaction of noneAbove" [value]="b2bCompetitorDissatisfaction" selected >
                                               {{b2bCompetitorDissatisfaction.name}}
                                      </mat-option>
                            </mat-select>
                      <mat-error *ngIf="assessmentForm.controls['pmfB2BCompetitorDissatisfaction'].hasError('required')">
                        Please select an answer
                      </mat-error>
                    </mat-form-field>
                  </div>-->
                </div>
              </div>
            <div #B2C style="display:none">
                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width">
                      <label>Finish the sentence. We're targeting consumers of a specific...?
                      </label>
                      <mat-select *ngIf="!isNoneB2CTM" placeholder="" formControlName="B2CTargetMarket" multiple >
                                <mat-option *ngFor="let B2CTM of B2CTargetMarketFull"  [value]="B2CTM"> {{B2CTM.name}} </mat-option>
                                <mat-option (onSelectionChange)="isNoneSelected(41)"  *ngFor="let B2CTM of noneAbove"  [value]="B2CTM">     {{B2CTM.name}} </mat-option>                   
                      </mat-select>
                      <mat-select *ngIf="isNoneB2CTM" placeholder=""  formControlName="B2CTargetMarket" multiple>                         
                                <mat-option (click)="isNoneSelected(41)" *ngFor="let B2CTM of noneAbove"  [value]="B2CTM" selected >    {{B2CTM.name}}  </mat-option>
                      </mat-select>
                      <!--<mat-error *ngIf="assessmentForm.controls['B2BTM'].hasError('required')">
                        Please select all that apply
                      </mat-error>-->
                    </mat-form-field>
                  </div>
                <!--  <div class="col">
                    <mat-form-field class="full-width">
                      <label>In which case do you think your consumer customers are dissatisfied with your competitors?</label>  
                            <mat-select *ngIf="!isNoneMI11" placeholder="" formControlName="pmfB2CCompetitorDissatisfaction" multiple >
                                          <mat-option
                                           *ngFor="let b2cCompetitorDissatisfaction of pmfB2CCompetitorDissatisfactionFull"      [value]="b2cCompetitorDissatisfaction">
                                                    {{b2cCompetitorDissatisfaction.name}}
                                          </mat-option>
                                          <!-- <mat-option (onSelectionChange)="isNoneSelected(211)"  *ngFor="let oSupplierType of offerSupplierTypeNone"> {{oSupplierType.name}} </mat-option> 
                                          <mat-option (click)="isNoneSelected(39)" *ngFor="let nbv of noneAbove" [value]="nbv">
                                                    {{nbv.name}}
                                          </mat-option>
                            </mat-select>
                            <mat-select *ngIf="isNoneMI11" placeholder=""  formControlName="pmfB2CCompetitorDissatisfaction" multiple>
                                      <mat-option (click)="isNoneSelected(39)"  *ngFor="let b2cCompetitorDissatisfaction of noneAbove" [value]="b2cCompetitorDissatisfaction" selected >
                                               {{b2cCompetitorDissatisfaction.name}}
                                      </mat-option>
                            </mat-select>
                      <mat-error *ngIf="assessmentForm.controls['pmfB2CCompetitorDissatisfaction'].hasError('required')">
                        Please select an answer
                      </mat-error>
                    </mat-form-field>
                  </div>-->
                </div>
            </div>
            <div class="row">
              <div class="col" >
                <mat-form-field class="full-width">
                  <label>Tell us about your website</label>
                  <mat-select placeholder=" " formControlName="marketingWebsite">
                    <mat-option *ngFor="let mWebsite of marketingWebsite" [value]="mWebsite">
                      {{mWebsite.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['marketingWebsite']">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>Which best describes your social media presence?</label>
                  <mat-select placeholder=" " formControlName="marketingSocialMedia">
                    <mat-option *ngFor="let mSocialMedia of marketingSocialMedia" [value]="mSocialMedia">
                      {{ mSocialMedia.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['marketingSocialMedia']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              </div>
                <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>How comfortable are you in your marketing efforts and understanding how effective they are?</label>
                    <mat-select placeholder=" " formControlName="marketingEffectiveness">
                      <mat-option *ngFor="let mEffectiveness of marketingEffectiveness" [value]="mEffectiveness">
                        {{ mEffectiveness.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketingEffectiveness']">
                      Please select yes or no
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>Do you have material to showcase your business when networking? (Ex. Capabilities statement, business cards, etc.)</label>
                    <mat-select placeholder=" " formControlName="marketingNetworkMaterial">
                      <mat-option *ngFor="let mNetworkMaterial of marketingNetworkMaterial" [value]="mNetworkMaterial">
                        {{ mNetworkMaterial.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketingNetworkMaterial']">
                      Please select yes or no
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row"> 
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>How consistent and professional is your brand?</label>
                    <mat-select placeholder=" " formControlName="marketingBrand">
                      <mat-option *ngFor="let mBrand of marketingBrand" [value]="mBrand">
                        {{ mBrand.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketingBrand']">
                      Please select yes or no
                    </mat-error>
                  </mat-form-field>
                </div>
                <div #CustomerEngagement style="display:none"> 
                <div class="col">
                  <mat-form-field class="full-width">
                    <label> How is your customer engagement?
                    </label>
                    <mat-select placeholder="" formControlName="customerEngagement">
                      <mat-option  *ngFor="let cEngagement of customerEngagement" [value]="cEngagement">
                        {{cEngagement.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['customerEngagement'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
                </div>
                <div #CustomerService style="display:none"> 
                <div class="col">
                  <mat-form-field class="full-width">
                    <label> How would others describe your customer service?
                    </label>
                    <mat-select placeholder="" formControlName="customerService">
                      <mat-option  *ngFor="let cService of customerService" [value]="cService">
                        {{cService.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['customerService'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
                </div>
            </div>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </form>
      </mat-step>
      <mat-step [stepControl]="assessmentForm">
        <form [formGroup]="assessmentForm">
          <ng-template matStepLabel>Legal</ng-template>
          <label>Let's assess your legal operations.</label>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <label>What is your registration status?</label>
            <mat-select placeholder="" formControlName="busiRegType">
              <mat-option *ngFor="let registration of busiRegType" (onSelectionChange)="handleOperatingAgreement($event, registration.name)" [value]="registration">
                {{ registration.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['busiRegType'].hasError('required')">
              Registration Type
            </mat-error>
          </mat-form-field>
        </div>
        <div #OperatingAgreement style="display:none">
        <div class="col">
          <mat-form-field class="full-width">
            <label>Do you have a solid operating agreement?</label>
            <mat-select placeholder="" formControlName="legalOpAgreement" >
              <mat-option *ngFor="let lOpAgreement of legalOpAgreement" [value]="lOpAgreement"  >
                {{ lOpAgreement.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['legalOpAgreement'].hasError('required')">
              Please enter a value
            </mat-error>
          </mat-form-field>
        </div>
        </div>
        </div>
        <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <label>Do you have good disclaimers?</label>
            <mat-select placeholder="" formControlName="legalDisclaimers">
              <mat-option *ngFor="let lDisclaimers of legalDisclaimers" [value]="lDisclaimers">
                {{ lDisclaimers.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['legalDisclaimers'].hasError('required')">
              Please enter a value
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="full-width">
            <label>In terms of intellectual property, the business...</label>
            <mat-select placeholder="" formControlName="legalIP" >
              <mat-option *ngFor="let legaIP of legalIP" [value]="legaIP">
                {{ legaIP.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="assessmentForm.controls['legalIP'].hasError('required')">
              Please enter a value
            </mat-error>
          </mat-form-field>
        </div>
        </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
        </form>
        </mat-step>
        <mat-step [stepControl]="assessmentForm">
          <form [formGroup]="assessmentForm">
            <ng-template matStepLabel>Finance & Operations</ng-template>
            <label>Great! Now what about Finance and General Operations.</label>
              <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>Do you actively use a payment processing system or have one set up?</label>
                  <mat-select placeholder=" " formControlName="financePaymentSystem">
                    <mat-option *ngFor="let fPaymentSystem of financePaymentSystem" [value]="fPaymentSystem">
                      {{ fPaymentSystem.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['financePaymentSystem']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>Do you actively use accounting software or have one set up?</label>
                  <mat-select placeholder=" " formControlName="financeAccountingSystem">
                    <mat-option *ngFor="let fAccountingSystem of financeAccountingSystem" [value]="fAccountingSystem">
                      {{ fAccountingSystem.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['financeAccountingSystem']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
            </div>     
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>Do you have thorough standard operating procedures on how to run your business?</label>
                  <mat-select placeholder="" formControlName="operatingSOP" >
                    <mat-option *ngFor="let pSOP of operatingSOP" [value]="pSOP">
                      {{ pSOP.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['operatingSOP'].hasError('required')">
                    Please enter a value
                  </mat-error>
                </mat-form-field>
              </div>
              <div #OperatingProductionProcess style="display:none"> 
              <div class="col">
                <mat-form-field class="full-width" >
                  <label>Do you have a consistent and stable production process for the product(s) you offer?</label>
                  <mat-select placeholder="" formControlName="operatingProductionProcess">
                    <mat-option *ngFor="let oProductionProcess of operatingProductionProcess" [value]="oProductionProcess">
                      {{ oProductionProcess.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['operatingProductionProcess'].hasError('required')">
                    Please enter a value
                  </mat-error>
                </mat-form-field>
              </div>
              </div>
              </div>       
            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>
            </form>
          </mat-step>
        <mat-step [stepControl]="assessmentForm">
          <form [formGroup]="assessmentForm">
          <ng-template matStepLabel>Team</ng-template>
      <!--Team-->
            <label>
              We’re in the home stretch, tell us about your team. If you're a team of 1, still answer the questions according to yourself!
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How many team members are on the team?</label>
                  <mat-icon class="matTooltip" matSuffix
                  matTooltip="Including full, part-time, contractors, etc.">info
                </mat-icon>
                  <input matInput type="number" placeholder="" formControlName="teamMembersQuan"
                    [(ngModel)]="teamMembersQuanCheck" (change)="handleTeamQuanQuestions()">
                  <mat-error *ngIf="assessmentForm.controls['teamMembersQuan']">
                    Please enter a number
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>Has anyone on the core or executive team started or managed a business before?</label>
                  <mat-select placeholder="" formControlName="teamLeaderSerialEntrp">
                    <mat-option *ngFor="let tLeaderSerialEntrp of boolAnswer" [value]="tLeaderSerialEntrp">
                      {{ tLeaderSerialEntrp.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamLeaderSerialEntrp']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>What skills are your team strong in?
                  </label>
                  <mat-select *ngIf="!isNoneT2" placeholder="" formControlName="teamRole" multiple >
                            <mat-option *ngFor="let tRole of teamRoleFull"  [value]="tRole"> {{tRole.name}} </mat-option>
                            <mat-option (onSelectionChange)="isNoneSelected(42)"  *ngFor="let tRole of noneAbove"  [value]="tRole">     {{tRole.name}} </mat-option>                   
                  </mat-select>
                  <mat-select *ngIf="isNoneT2" placeholder=""  formControlName="teamRole" multiple>                         
                            <mat-option (click)="isNoneSelected(42)" *ngFor="let tRole of noneAbove"  [value]="tRole" selected >    {{tRole.name}}  </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamRole'].hasError('required')">
                    Please select all that apply
                  </mat-error>
                </mat-form-field>
              </div>
             
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How well does the team know the business industry? </label>
                  <mat-select placeholder="" formControlName="teamIndustryKnowledge">
                    <mat-option *ngFor="let tIndustryKnowledge of teamIndustryKnowledge" [value]="tIndustryKnowledge">
                      {{ tIndustryKnowledge.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamIndustryKnowledge']">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How much time do most team members have to dedicate to the business per week? </label>
                  <mat-select placeholder="" formControlName="teamTime">
                    <mat-option *ngFor="let tTime of teamTime" [value]="tTime">
                      {{ tTime.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamTime']">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>What is the ability of the team to develop or sell the product or service through its
                    network?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip=" Think about the ability to develop the product/service and sales funnels.">info
                    </mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="teamNetwork">
                    <mat-option *ngFor="let tNetwork of teamNetwork" [value]="tNetwork">
                      {{tNetwork.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamNetwork'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div> 
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>What is the team’s ability to set, prioritize, track and meet goals when given a
                    timeline?</label>
                  <mat-select placeholder="" formControlName="teamTimeManage">
                    <mat-option *ngFor="let tTimeManage of teamTimeManage" [value]="tTimeManage">
                      {{tTimeManage.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamTimeManage'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How often does the team encounter internal dysfunction or unproductivity?</label>
                  <mat-select placeholder="" formControlName="teamUnproductivity">
                    <mat-option *ngFor="let tProductivity of teamUnproductivity" [value]="tProductivity">
                      {{tProductivity.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamUnproductivity'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How passionate is the team about the business?</label>
                  <mat-select placeholder="" formControlName="teamPassion">
                    <mat-option *ngFor="let tPassion of teamPassion" [value]="tPassion">
                      {{tPassion.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamPassion'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>How is the team's work-life balance?</label>
                  <mat-select placeholder="" formControlName="teamWorkLife">
                    <mat-option *ngFor="let tWorkLife of teamWorkLife" [value]="tWorkLife">
                      {{tWorkLife.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamWorkLife'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class ="row">
              <div #TeamHiring style="display:none"> 
            <div class="col">
              <mat-form-field class="full-width">
                <label>Do you want to hire?</label>
                <mat-select placeholder="" formControlName="teamHiring">
                  <mat-option *ngFor="let tHiring of teamHiring" (onSelectionChange)="handleHiringQuestions($event, tHiring.name)" [value]="tHiring">
                    {{tHiring.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="assessmentForm.controls['teamHiring'].hasError('required')">
                  Please select one
                </mat-error>
              </mat-form-field>
            </div>
            </div>
          </div>
          <div #HRRetention style="display:none"> 
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>What do you currently do to foster company culture and team member retention?</label>
                  <mat-select placeholder="" formControlName="hrEmployeeRetention" multiple>
                    <mat-option *ngFor="let pEmployeeRetention of hrEmployeeRetention" [value]="pEmployeeRetention">
                      {{ pEmployeeRetention.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['hrEmployeeRetention'].hasError('required')">
                    Please enter a value
                  </mat-error>
                </mat-form-field>
        </div>
        </div>
        </div>
        <div #HRHiringPractices style="display:none"> 
        <div class="row">
        <div class="col">
          <mat-expansion-panel (opened)="panelOpenState = true"
          (closed)="panelOpenState = false" style="width: 50%">
            <mat-expansion-panel-header>
              <mat-panel-title>
                What is your level of quality and comfortability for these hiring practices?
              </mat-panel-title>
            </mat-expansion-panel-header>    
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Hiring Practice</th>
              </tr>
            </thead>
            <tbody>
               <div formArrayName="hiringPractices">
                <tr>
                  <td>
                  <p>Interviewing</p>
                </td>
                <mat-radio-group formControlName="hiringPracticesInterviewing">
                <td>
                  Does not exist
                  <mat-radio-button [value] = '0' ></mat-radio-button>
                </td>
                <td>
                  Needs work
                  <mat-radio-button [value] = '1'></mat-radio-button>
                </td>
                <td>
                  Good to go
                  <mat-radio-button [value] = '2'></mat-radio-button>
                </td>
              </mat-radio-group>
              </tr>
              <tr>
                <td>
                  <p>Job Descriptions</p>
                </td>
                <mat-radio-group formControlName="hiringPracticesJobDescrp">
                  <td>
                    Does not exist
                    <mat-radio-button [value] = '0' ></mat-radio-button>
                  </td>
                  <td>
                    Needs work
                    <mat-radio-button [value] = '1'></mat-radio-button>
                  </td>
                  <td>
                    Good to go
                    <mat-radio-button [value] = '2'></mat-radio-button>
                  </td>
              </mat-radio-group>
              </tr>
              <tr>
                <td>
                  <p>Onboarding Process</p>
                </td>
                <mat-radio-group formControlName="hiringPracticesOnboarding">
                  <td>
                    Does not exist
                    <mat-radio-button [value] = '0' ></mat-radio-button>
                  </td>
                  <td>
                    Needs work
                    <mat-radio-button [value] = '1'></mat-radio-button>
                  </td>
                  <td>
                    Good to go
                    <mat-radio-button [value] = '2'></mat-radio-button>
                  </td>
              </mat-radio-group>
              </tr>
              <tr>
                <td>
                  <p>HR/employee Maintenance</p>
                </td>
                <mat-radio-group formControlName="hiringPracticesHR">
                  <td>
                    Does not exist
                    <mat-radio-button [value] = '0' ></mat-radio-button>
                  </td>
                  <td>
                    Needs work
                    <mat-radio-button [value] = '1'></mat-radio-button>
                  </td>
                  <td>
                    Good to go
                    <mat-radio-button [value] = '2'></mat-radio-button>
                  </td>
              </mat-radio-group>
              </tr>
              </div>
            </tbody>
          </table>
      </mat-expansion-panel>
    </div>
        </div>
        </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
         <button mat-button matStepperNext>Next</button>
        </div>
    </form>
        </mat-step>
        <mat-step [stepControl]="assessmentForm">
          <form [formGroup]="assessmentForm" novalidate (ngSubmit)="onSubmit()">
            <ng-template matStepLabel>Special Questions</ng-template>
            <label>These are questions from your organization or related to your industry. Coming Soon.</label>
          <div>
            <button mat-button matStepperPrevious>Back</button>
            <button mat-button>Submit</button>
          </div>
          </form>
          </mat-step>
        </mat-vertical-stepper>
      </div>


